


























import { Vue, Component } from "vue-property-decorator";

@Component
export default class Modal extends Vue {
  // for safari
  // https://github.com/vuejs/vue/issues/2501#issuecomment-273803579
  mounted(): void {
    document.body.appendChild(this.$el);
  }
}
